<!--suppress ALL -->
<script lang="ts">
import {statusVirtualAccounts} from '../../../util/PluralVariabels';
import {Component, Vue, Prop} from 'annotation';
import {cloneArray} from "../../../util/Underscore";

import GField from '../common/field/GField.vue';
import GSelect from '../common/select/GSelect.vue';

@Component
export default class VirtualStatusSelect extends Vue {

  @Prop({default: statusVirtualAccounts[0], type: String})
  private status: string;

  @Prop({default: false, type: Boolean})
  public skipLabel: boolean;

  @Prop({default: true, type: Boolean})
  public isFullwidth: boolean;

  @Prop({default: false, type: Boolean})
  public disabled: boolean;

  @Prop({
    default: () => 'Status',
    type: String
  })
  public label: string;

  @Prop({type: String, default: ""})
  public message: string;

  @Prop({type: String, default: ""})
  public type: string;

  public onSelectStatus(param: string) {
    if (this.status) {
    }

    const status = param || statusVirtualAccounts[0];

    this.$emit('update:status', status);
  }

  public render(createElement: Function) {
    const {$t, typeTugas, isFullwidth, label, message, type} = this;

    const mainAttr: any = {
      attrs: {disabled: this.disabled},
      props: {
        value: typeTugas, isFullwidth,
        placeholder: `${$t('label.choose')} ${label}`
      },
      on: {change: this.onSelectStatus}
    };

    const main: any = createElement(GSelect, mainAttr, cloneArray(statusVirtualAccounts).map((item: any) => {
      const option: any = {attrs: {value: item}};

      return createElement('option', option, item);
    }));

    if (this.skipLabel) {
      return main;
    }

    return createElement(GField, {props: {label, message, type}}, [main]);
  }
}
</script>
